import { useMemo } from 'react';
import {
  HL7MessageDirection,
  HL7MessageGroup,
  QueryFactory,
  SortDirection,
} from '@lmt/shared-types';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import { addDays } from 'date-fns';
import { isEmpty } from '@lmt/unicorn-shared/app/components/merge-assistant/form/components/common';

export function usePatientReminder(patientId: number) {
  const claims = useClaims();
  const patientQuery = QueryFactory.PatientQuery.useGetPatientQuery(patientId);
  const enabled = claims.permissions.hl7 && !!patientQuery.data?.subtenantId;
  const hl7MessageQuery = QueryFactory.HL7MessageQuery.useGetMessagesQuery(
    {
      direction: HL7MessageDirection.Incoming,
      patientId: patientId,
      pagination_Offset: 0,
      pagination_Limit: 1,
      sorting_SortField: 'dateTime',
      sorting_SortDirection: SortDirection.Desc,
    },
    {
      enabled: enabled,
    },
  );
  const { data: hl7TemplateRules } =
    QueryFactory.HL7TemplateRulesQuery.useGetQuery(
      {
        isActive: true,
        messageGroup: HL7MessageGroup.Query,
        subtenantId: patientQuery.data?.subtenantId,
      },
      {
        enabled: enabled,
      },
    );

  const patientReminder = useMemo(() => {
    if (
      !claims.permissions.hl7 ||
      isEmpty(hl7TemplateRules) ||
      !hl7MessageQuery.data?.totalCount
    ) {
      return {
        lastUpdatedDate: null,
        enabled: false,
      };
    }
    const date = hl7MessageQuery.data!.data[0].dateTime;
    const enabled = !date || addDays(new Date(), -14) > date;
    return {
      lastUpdatedDate: date,
      enabled: enabled,
    };
  }, [hl7TemplateRules, hl7MessageQuery.data]);

  return patientReminder;
}
